<template>
  <div v-if="body_show" class="task-box pb190">
    <div class="task-title">行业调研参考资料</div>
    <!-- 下拉 -->
    <van-cell-group class="grouping">
      <van-field
        placeholder=""
        v-model="birthdate"
        @click="showPicker()"
        readonly
      />
      <label
        class="choose_lable"
        :style="{ 'background-position-y': arrow ? 'bottom' : 'top' }"
      ></label>
    </van-cell-group>
    <!-- 说明字 默认 -->
    <div v-if="!show_result">
      <div class="cart-auto">
        <p class="cart-box-head">行业信息卡简介:</p>
        <p class="cart-box-con">
          进入P1项目，我们需要对目标行业进行研究分析。这个部分对于你制定个人战略来说，十分有价值，但是需要大量的信息检索和分析，可能会花费很多时间。
        </p>
        <p class="cart-box-con">
          为此，我们为大家准备了几十张行业信息卡，每张卡片包含了一个行业细分赛道的重要行研信息，帮你快速纵览行业格局，更快更好的做好行业分析。如果你不确信自己到底喜欢哪个行业，也可以先浏览多个行业和赛道的信息，最后落到一个爱干、能干，而且处于趋势当中的行业赛道。
        </p>
      </div>
      <div class="cart-auto">
        <p class="cart-box-head">行业信息卡的ESTO模型：</p>
        <p class="cart-box-con">Environment 宏观环境</p>
        <p class="cart-box-con">Situation 行业状况</p>
        <p class="cart-box-con">Trend 热点趋势</p>
        <p class="cart-box-con">Opportunities 从业信息</p>
      </div>
      <div class="cart-auto">
        <p class="cart-box-head">行业信息卡简介:</p>
        <div class="cart-tab-img">
          <img src="@a/occupation_inf_1.png" alt="" />
          <img src="@a/occupation_inf_2.png" alt="" />
          <img src="@a/occupation_inf_3.png" alt="" />
          <img src="@a/occupation_inf_4.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 说明字 数据 -->
    <div v-else>
      <!-- cart f -->
      <div class="el-cart">
        <div class="msg-box">
          <div class="msg-type">
            <h2>新精英行业调研卡</h2>
            <h3>{{ birthdate }}</h3>
          </div>
          <div class="clearfix msg-con">
            <div class="pull-left logo-box">
              <div class="">
                <img src="../../../assets/ind_report_logo.png" alt="" />
              </div>
              <p>*本报告版权属于新精英人才加速器，持续更新中。</p>
            </div>
            <div class="pull-right qr-box">
              <img
                class="qrImg"
                src="../../../assets/ind_report_qrcode.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <!-- e -->
      <div class="el-cart box-rgbLogo mt100">
        <div class="borders">
          <div>
            <div>
              <img src="@a/occupation-cart-head-1.png" alt="" />
            </div>
            <div class="con">
              <h3>P 当前该行业的政策环境如何，监管是严格或宽松？</h3>
              <p v-html="result.e_content_1"></p>
              <h3>E&S 当前经济环境、社会需求、大众心理有怎样的变化？</h3>
              <p v-html="result.e_content_2"></p>
              <h3>T 技术发展趋势是怎样？可在行业内运用结合的有哪些？</h3>
              <p v-html="result.e_content_3"></p>
            </div>
          </div>
        </div>
      </div>
      <!-- s -->
      <div class="el-cart box-rgbLogo">
        <div class="borders">
          <div>
            <div>
              <img src="@a/occupation-cart-head-2.png" alt="" />
            </div>
            <div class="con">
              <h3>这个行业的规模如何？增速如何？有什么特点？</h3>
              <p v-html="result.s_content_1"></p>
              <h3>该行业有哪些细分行业赛道？有什么新赛道？</h3>
              <p v-html="result.s_content_2">{{}}</p>
              <h3>这个行业内的头部公司？</h3>
              <p v-html="result.s_content_3"></p>
            </div>
          </div>
        </div>
      </div>
      <!-- t -->
      <div class="el-cart box-rgbLogo">
        <div class="borders">
          <div>
            <div>
              <img src="@a/occupation-cart-head-3.png" alt="" />
            </div>
            <div class="con">
              <h3>这个行业当前的趋势和热点是什么？</h3>
              <p v-html="result.t_content_1"></p>
              <h3>这个行业所面临的痛点有那些？</h3>
              <p v-html="result.t_content_2"></p>
            </div>
          </div>
        </div>
      </div>
      <!-- o -->
      <div class="el-cart box-rgbLogo">
        <div class="borders">
          <div>
            <div>
              <img src="@a/occupation-cart-head-4.png" alt="" />
            </div>
            <div class="con">
              <h3>行业内的人才需求热点？</h3>
              <p v-html="result.o_content_1"></p>
              <h3>热门职位及对应薪酬是怎样的？（北上广深为参考）</h3>
              <div class="clearfix contrast">
                <div v-html="result.o_content_2" class="pull-left"></div>
                <div v-html="result.o_content_3" class="pull-right"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- fixel -->
      <div @click="getReportImg" class="tip-buttom">保存图片转发给好友</div>
    </div>
    <!-- picker -->
    <van-popup v-model="picker_show" position="bottom"  @close="pickerShowClick(false)">
      <van-picker
        show-toolbar
        :columns="columns"
        @change="onChange"
        @confirm="confirm"
      />
    </van-popup>
    <!--  -->
    <van-popup class="explain" v-model="alertModule1">
      <div>
        <div class="pps">
          <img :src="imgHref" alt="" />
        </div>
      </div>
      <p class="tips">长按保存图片</p>
    </van-popup>
  </div>
</template>
<script>
import { get_select, get_card, buildResearch } from "@/api/course";
export default {
  data() {
    return {
      imgHref: "",
      body_show: false,
      picker_show: false,
      alertModule1: false,
      show_result: false,
      // 值
      birthdate: "",
      result: {},
      // 选择元素
      select_els: [],
      // 下拉数据
      citys: [],
      columns: [],
      // 缓存数据
      cacheData: {
        one: {},
        two: {},
      },
      cacheItem: null,
    }
  },
  methods: {
	/*
	*@Description: vue中mini-ui或vant popup与picker结合在iphone手机穿透问题
	*@MethodAuthor:  Zhang Xiao Guang
	*@Date: 2019-11-28 12:18:35
	*/
	pickerShowClick(newval) {
	let self = this;
	if (newval) {
		document.getElementsByTagName("body")[0].addEventListener('touchmove', self.preventDefault, {
		passive: false
		}); //阻止默认事件
	} else {

		document.getElementsByTagName("body")[0].removeEventListener('touchmove', self.preventDefault, {
		passive: false
		}); //打开默认事件
	}
	},
    getReportImg() {
      let arr = this.cacheItem;
      this.$toast.loading({
        mask: true,
        message: "加载中...",
      });
      buildResearch({
        profession_id: this.cacheData.one[arr[0]],
        job_id: this.cacheData.two[arr[1]],
      }).then((data) => {
        this.$toast.clear();
        if (typeof data.href === "string") {
          this.alertModule1 = true;
          this.imgHref = data.href;
        }
      });
    },
    onChange(picker, values) {
      picker.setColumnValues(1, this.citys[values[0]]);
    },
    confirm(arr) {
      this.cacheItem = arr;
      this.birthdate = `${arr[0]}/${arr[1]}`;
      this.select_els = arr;
      this.picker_show = false;
      setTimeout(() => {
        this.getWorkInfo(arr);
      }, 100);
    },
    showPicker() {
		this.pickerShowClick(true);
    	this.picker_show = true;
    },
    factoryData(data) {
      // 加工数据
      let curData = {};
      let cacheData = {};
      for (let arg of data.profession) {
        curData[arg.name] = [];
        cacheData[arg.id] = arg.name;
        // 缓存
        this.cacheData.one[arg.name] = arg.id;
      }
      for (let arg of data.job) {
        let key = cacheData[arg.pid];
        curData[key].push(arg.name);
        // 缓存
        this.cacheData.two[arg.name] = arg.id;
      }
      return curData;
    },
    // 行业详细对比信息
    getWorkInfo(arr) {
      this.$toast.loading({
        mask: true,
        message: "加载中...",
      });
      get_card({
        profession_id: this.cacheData.one[arr[0]],
        job_id: this.cacheData.two[arr[1]],
      }).then((data) => {
        this.$toast.clear();
        for (let attr in data) {
          if (typeof data[attr] === "string") {
            let val = data[attr].replace(/\n/gi, "<br/><br/>");
            data[attr] = val;
          }
        }
        this.result = data;
        this.show_result = true;
      });
    },
    // 下拉信息
    pullPickerData() {
      // loading
      this.$toast.loading({
        mask: true,
        message: "加载中...",
      });
      // pull
      get_select().then((data) => {
        this.$toast.clear();
        // 加工数据
        let resultData = this.factoryData(data);
        this.citys = resultData;
        let firstKey = data.profession[0].name;

        // 设置数据
        this.columns = [
          {
            values: Object.keys(this.citys),
            className: "column1",
          },
          {
            values: this.citys[firstKey],
            className: "column2",
            defaultIndex: 0,
          },
        ];
        // 显示
        this.body_show = true;
      });
    },
  },
  created() {
    this.pullPickerData();
  },
};
</script>
<style lang="scss" scoped>
@import "@s/taskStyle.scss";
.pb190 {
  padding-bottom: 190px;
}
.mt100 {
  margin-top: 100px !important;
}
.box-rgbLogo {
  background: #fff url(../../../assets/ind_report_rgb_logo.png) center top
    repeat !important;
}
.msg-box {
  .msg-type {
    padding-bottom: 40px;
    border-bottom: 40px;
    border-bottom: 2px solid #ccc;
    * {
      font-weight: bold;
    }
    h2 {
      font-size: 32px;
      color: #333;
    }
    h3 {
      margin-top: 20px;
      font-size: 28px;
      color: #eb5032;
    }
  }
  .msg-con {
    padding: 14px 14px 0 0;
  }
  .logo-box {
    img {
      height: 38px;
    }
    p {
      font-size: 20px;
      margin-top: 15px;
      color: #999;
    }
  }
  .qr-box {
    img {
      width: 88px;
    }
  }
}
.cart-auto {
  margin-top: 60px;
  color: #999;
  img {
    width: 276px;
    margin-right: 30px;
    margin-top: 30px;
  }
  .cart-box-head {
    font-size: 30px;
  }
  .cart-box-con {
    font-size: 26px;
    margin-top: 28px;
  }
}
.el-cart {
  margin-top: 50px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  .borders {
    border: 2px solid #eb5032;
    border-radius: 10px;
    padding: 20px;
  }
  .con {
    font-size: 26px;
    color: #333;
    h3 {
      color: #eb5032;
      margin-top: 47px;
      font-weight: bold;
    }
    p {
      margin-top: 28px;
    }
  }
  img {
    max-width: 100%;
  }
}
.contrast {
  margin-top: 50px;
  line-height: 40px;
  > div:nth-child(1) {
    width: 60%;
    text-align: left;
  }
  > div:nth-child(2) {
    width: 40%;
    text-align: right;
  }
}
.tip-buttom {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100px;
  line-height: 100px;
  background: #eb5032;
  text-align: center;
  font-size: 34px;
  color: #fff;
}
.explain {
  padding: 0;
  width: 80%;
  background: rgba(0, 0, 0, 0);
  img {
    max-width: 100%;
  }
  .tips {
    margin-top: 30px;
    text-align: center;
    font-size: 26px;
    color: #fff;
    margin-bottom: 30px;
  }
}
</style>